import { render } from "./ModalText.vue?vue&type=template&id=291768f2&scoped=true"
import script from "./ModalText.vue?vue&type=script&lang=js"
export * from "./ModalText.vue?vue&type=script&lang=js"

import "./ModalText.vue?vue&type=style&index=0&id=291768f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-291768f2"

export default script